import angular from 'angular';

import Component from './entity-header.component';

const Module = angular
    .module('control-room.commons.forms.components.entity-header', [])
    .component('crEntityHeader', Component);

export default Module;
